import React, { useContext, useEffect, useState } from "react";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { AppContext } from "../../contexts/AppContext";
import { INITIAL_APP_STATE } from "../../contexts/AppContext";
import { redirectToRealMe } from "../../Services/apiService";
import ExternalLink from "../ExternalLink/ExternalLink.tsx";
import BackIconWhite from "../../assets/images/BackIconWhite.svg";

const ApplicationSubmit = ({ handleNext, handleCancel, handleBack }) => {
  const { appState, setAppState } = useContext(AppContext);
  const [displayData, setDisplayData] = useState(null);

  useEffect(() => {
    const payload = appState?.requestPayload;
    setDisplayData({
      givenNames: payload?.applicant?.givenNames || "",
      familyName: payload?.applicant?.familyName || "",
      namesKnownAs: payload?.applicant?.namesKnownAs,
      applicationId: payload?.applicationId,
      emailAddress: payload?.applicant?.emailAddress,
      applicationFlowCode: payload?.applicationFlowCode,
      referee: payload?.referee,
    });
    setAppState(INITIAL_APP_STATE);
  }, []);

  if (!displayData) return null;

  const givenNameDiff =
    (displayData.givenNames ?? "").trim().toLowerCase() !==
    (displayData.namesKnownAs?.[0]?.givenNames ?? "").trim().toLowerCase();

  const familyNameDiff =
    (displayData.familyName ?? "").trim().toLowerCase() !==
    (displayData.namesKnownAs?.[0]?.familyName ?? "").trim().toLowerCase();

  return (
    <>
      <div className="intro">
        <h1 className="intro-title-mi" lang="mi-NZ">
          {displayData.applicationFlowCode === 100000001
            ? `Ngā mihi, kua tae mai tō tono ki te whakahou i tō tuakiri hāpono`
            : `Ngā mihi, kua tae mai tō tono`}
        </h1>
        <hr />
        {displayData.applicationFlowCode === 100000001 ? (
          <h1 className="intro-title">
            Thanks, we've received your application to renew your verified
            identity
          </h1>
        ) : (
          <h1 className="intro-title">
            Thanks, we've received your application
          </h1>
        )}
        <div className="step-container">
          <div className="step-container-box applicant-details">
            <span className="value">
              <strong>{`${displayData.givenNames} ${displayData.familyName}`}</strong>
            </span>
            {(givenNameDiff || familyNameDiff) && (
              <span className="label-noblock">
                Other name:{" "}
                <strong>{`${
                  displayData.namesKnownAs?.[0]?.givenNames || ""
                } ${displayData.namesKnownAs?.[0]?.familyName || ""}`}</strong>
              </span>
            )}
            <span className="label-noblock">
              Your application number:{" "}
              <strong>{displayData.applicationId}</strong>
            </span>
          </div>
        </div>

        <div className="step-container">
          <h2 className="step-title mb-2">What happens next?</h2>
          <p className="mb-4">
            {displayData.referee?.givenNames
              ? "We're processing your application and contacting your referee. We'll contact you if we need more information. Check our website for current processing times."
              : "We're processing your application. Check our website for current processing times."}
          </p>

          <label className="terms-label">
            <ExternalLink
              href="https://www.realme.govt.nz/help/#how-long-does-it-take-to-get-a-realme-verified-identity/"
              text="RealMe — How long it takes to get a verified identity"
            />
          </label>

          <p className="mb-4">
            {displayData.applicationFlowCode === 100000001
              ? "You'll receive an email confirming your application for a renewed verified identity. We'll contact you if we need more information. When your verified identity is ready to use, we'll send an email to "
              : "You'll receive an email confirming your application for a verified identity. We'll contact you if we need more information. When your verified identity is ready to use, we'll send an email to "}{" "}
            <strong>{displayData.emailAddress}</strong>.
          </p>

          <label className="terms-label">
            If you have any questions,{" "}
            <ExternalLink
              href="https://www.realme.govt.nz/contact-us/"
              text="contact us."
            />
          </label>
        </div>

        <div className="step-button-container">
          <SubmitButton
            text={"Back to RealMe"}
            onClick={redirectToRealMe}
            Icon={BackIconWhite}
          />
        </div>
      </div>
    </>
  );
};

export default ApplicationSubmit;
